const config = {
    api_url : process.env.REACT_APP_API_URL ,
    img_url : process.env.REACT_APP_IMG_URL ,
}

export default config ; 